import React, {useState, useEffect,useRef} from 'react';
import { connect } from 'react-redux';
import { useNavigate,Outlet } from 'react-router-dom';
import { getCaptcha,reg, sendCode} from '../../api';
import {  useLocation } from 'react-router-dom';
import { message,Input } from 'antd';
import { CheckCircleTwoTone,LockOutlined,UserOutlined ,TeamOutlined,VerifiedOutlined} from '@ant-design/icons';
import { useTranslation } from 'react-i18next'
import bg5 from '../../assets/img/bg5.jpg'
import './reg.less'


    
const Reg = (props) => {

    const [num,setNum]=useState(0)
    const [fcode,setFcode]=useState("")
    const [phone, setPhone] = useState("")
    const [passLogin ,setPassLogin] = useState("")
    const [passPay ,setPassPay] = useState("")
    const [captchaVal,setCaptchaVal] = useState("")
    const [content,setContent] = useState("")
    const [captchaId,setCaptchaId] = useState("")
    const [count,setCount] = useState(60)
    const [code,setCode] = useState("")
    const navigate = useNavigate()

    const location = useLocation()
    const {pathname , search} = location

    var i="";
    let iarr=[]
    iarr = search.split('?i=')
    if(iarr.length>1){
        i = iarr[1].slice(0,12)
    }

    let sessioni=sessionStorage.getItem('i')  
    if(i!==1){
        sessionStorage.setItem('i',i);  
    }else{
        if(sessioni){
            i=sessioni;
        }else{
            sessionStorage.setItem('i',i); 
        }
    }


    var canReg = true
    

    const getCaptchaFunc = () =>{
        getCaptcha({closeLoading:false}).then(res=>{
            setCaptchaId(res.data.captchaid)
            setContent(res.data.content)
            setCaptchaVal("")
        })
    }
    
    const handleCountDown = (_seconds) => {
        if(_seconds===60){
            
            if(!/^1[3|4|5|6|7|8|9][0-9]\d{8}$/.test(phone)){
                message.error("手机号码格式不正确！")
                setPhone("")
                return;
            }
    
            localStorage.setItem("sendCodeTime",Date.now())
        }
       
        
            // data  { gee_token : 'xxxxxxxxxxxxxxxxxxxxxxxxxxxx' }
            // 获取到GeeToken处理业务逻辑
            sendCode({
                phone:phone
            }).then(res=>{
                if(res.code === 0){
                        // let second = 60;
                    let _count = _seconds;
                    const countDown = ()=> {
                     
                        // timer && clearTimeout(timer); //清除计时器
                        if( _count > 0){
                            // let second =
                            // countDownSecond--;
                            // let a  = countDownSecond - 1;
                            _count--;
                            setCount( _count );
                        }
                        if( _count === 0 ){
                            /*
                                _this.countDown = 60;//恢复60s设定
                                _this.isVerify = false;//不显示60s计时器
                                clearTimeout(count60Timeout)//清除计时器
                                return //结束方法的调用
                            */
                                _count = 60;
                            setCount( _count );
                            // clearTimeout( timer ); //清除计时器
                            return;
                        }
                        // let timer = setTimeout( countDown,1000 );
                        setTimeout( countDown,1000 );
                        
                    };
                    setTimeout( countDown,1000 );
                    message.success("发送成功！")
                }else{
                    message.error(res.msg)
                }
            
            },error=>{
                message.error("响应错误！")
            })
        
        
        
        
    };
    
    const send = () =>{
        
        // if(!/^1[3|4|5|6|7|8|9][0-9]\d{8}$/.test(phone)){
        //     message.error("手机号码格式不正确！")
        //     setPhone("")
        //     return;
        // }
        if(phone.length<6 || phone.length>16){
            message.error("用户名要求6-16位")
            setPhone("")
            return;
        }
        if(passLogin.length<8 || passLogin.length>16 || !/^(?![^a-zA-Z]+$)(?!\D+$)/.test(passLogin)){
            message.error("登陆密码必须8-16个字符，且包含字母和数字")
            setPassLogin("")
            return;
        }

        if(passPay.length!==6 || !/^[0-9]{1,20}$/.test(passPay)){
            message.error("支付密码必须为6位数字")
            setPassPay("")
            return;
        }

        if(fcode.length!=10){
            message.error("邀请码格式不对")
            return;
        }

        

        // if(code.length!==6 || !/^[0-9]{1,20}$/.test(code)){
        //     message.error("短信验证码必须为6位数字")
        //     setCaptchaVal("")
        //     return;
        // }

        // if(captchaVal.length===0){
        //     message.error("请填写验证码")
        //     return;
        // }
        if(canReg===false){
            return
        }
        canReg=false
        reg({
            phone:phone,
            passlogin:passLogin,
            passpay:passPay,
            fcode:fcode,
            // captchaid:captchaId,
            // captchaval:captchaVal,
            // verify:code
        }).then(res=>{
            if(res.code===2){
                message.error(res.msg)
                getCaptchaFunc()
                canReg=true
            }else if(res.code===1){
                message.error(res.msg)
                getCaptchaFunc()
                canReg=true
            }else if(res.code===3){
                message.error(res.msg)
                canReg=true
            }else{
                message.success(res.msg)
                setPhone("")
                setPassLogin("")
                setPassPay("")
                setCaptchaVal("")
                setCode("")
                getCaptchaFunc()
            }
            
        },err=>{
            message.error(err)
            canReg=true
        })
    }
    

    const goReg = () => {
       
        navigate("/reg",{
            state:{
                address:"asdasdasd"
            }
        })
    }

    const goLogin = () => {
        //window.open("https://mp-238860f4-0bf0-4745-ac2a-d2b28416584d.cdn.bspapp.com/cloudstorage/60b37cb6-03b3-4813-b3ac-07f6808d4ad0.apk")
        window.open("https://xiehe.shop/app-release.apk")
        return;
         navigate("/login",{
             state:{
                 address:"asdasdasd"
             }
         })
     }
 
 
   
    useEffect(() => {
        //clearTimer()
        
        window.scrollTo(0, 0)
        let nowTime = localStorage.getItem("sendCodeTime") || 0
        if(nowTime > 0 ){
            let left =  parseInt(( Date.now() - nowTime)/1000)
            
            if(left < 60) {
                handleCountDown(60-left)
            }
        }
        setFcode(i)
        // getCaptchaFunc()
        
        
    }, 
    // eslint-disable-next-line
    [num]);


    const myStyle={

        backgroundImage: 'url(' +bg5 + ')',//图片的路径,
        backgroundSize: 'cover',
        backgroundRepeat: 'no-repeat',
    };


    return (
        
        <>
            <div className=' h-screen w-full flex flex-col items-center ' style={myStyle}>
                <div className=' w-full h-auto flex flex-row justify-center'>
                {/* <img alt='rr' className=' mt-20 mb-7'  src={require('../../assets/img/logo.png')} style={{"width":"100px"}}></img> */}
                <span className=' mt-20 mb-7 font-bold text-xl text-white'>协和健康数字资产创富平台</span>
                </div>
                <div className=' ml-5 mr-5 px-5 rounded-lg bg-white pb-8'>
                    <div className=' w-full mt-8 inputView h-11 border50  flex flex-row justify-center items-center'>
                        <Input size="large" value={phone} onChange={(e)=>setPhone(e.target.value)}  placeholder="请输入用户名6-16位" prefix={<UserOutlined />} />
                    </div>
                    <div className=' w-full inputView h-11 border50  mt-3 flex flex-row justify-center items-center'>
                        <Input.Password onChange={(e)=>setPassLogin(e.target.value)} value={passLogin} placeholder="请输入登陆密码8-16位" prefix={<LockOutlined />}/>
                    </div>
                    <div className=' w-full inputView h-11 border50  mt-3 flex flex-row justify-center items-center'>
                    <Input.Password onChange={(e)=>setPassPay(e.target.value)} value={passPay} placeholder="请输入6位支付密码" prefix={<LockOutlined />}/>
                    </div>
                    <div className=' w-full inputView h-11 border50  mt-3 flex flex-row justify-center items-center'>
                        <Input type='text' onChange={(e)=>setFcode(e.target.value)} value={fcode}  size="large" placeholder="邀请码" prefix={<TeamOutlined />} />
                    </div>
                    {/* <div className=' w-full inputView h-11 border50  mt-3 flex flex-row justify-center items-center'>
                        <Input type='text' size="large" onChange={(e)=>setCode(e.target.value)} value={code} placeholder="短信验证码" prefix={<VerifiedOutlined />} />
                        {
                            count>=60?(
                                <div onClick={()=>handleCountDown(60)} className=' w-32 text-right mr-4 text-blue-500 font-semibold'>发送验证码</div>
                            ):(
                                <div className=' w-32 text-right mr-4 text-gray-300 font-semibold'>{count}秒后</div>
                            )
                        }
                    
                       
                    </div>
                     */}
                    {/* <div className=' w-full inputView h-11 border50  mt-3 flex flex-row justify-center items-center'>
                        <Input type='text' size="large" onChange={(e)=>setCaptchaVal(e.target.value)} value={captchaVal} placeholder="验证码" prefix={<VerifiedOutlined />} />
                        <img onClick={getCaptchaFunc} alt='rr' className=' ml-2'  src={content} style={{"width":"160px","height":"44px"}}></img>
                    </div> */}
                    <div className=' w-full text-xs flex flex-row justify-center items-center mt-4'>
                    <CheckCircleTwoTone style={{"fontSize":"16px"}} className=' mr-1 ' />
                    我已经阅读并同意 
                    <span className=' text-blue-500' >
                        《用户协议》
                        </span>和<span className=' text-blue-500'>《隐私政策》</span>
                    </div>
                    <div className=' w-full text-xs flex flex-row justify-center items-center mt-5'>
                    
                    
                    {/* <span className=' text-red-500' >
                        如无法下载APP，请点击右上角···选择用手机默认浏览器打开下载
                        </span> */}
                    </div>
                    <div className='w-full flex flex-row justify-between items-center'>
                    <button onClick={send} className="w-full h-12 regbtn1 mt-2" >立即注册</button>
                    {/* <button onClick={goLogin} className="w-6/12 h-12 regbtn1 mt-6 ml-1" >安卓APP</button> */}
                    </div>
                </div>
                <div className=' mt-4 text-white'>
                    ——  下载APP  ——
                </div>
                <div className=' mt-3'>
                <img onClick={goLogin} alt='rr' className=' rounded-lg' src={require('../../assets/img/android.jpg')} style={{"width":"50px"}}></img>
                <span className=' text-white text-sm'>Android</span>
                </div>
                
            </div>
       
        </>
    );
}

export default Reg


